import React from 'react';
import './Tools.css';
import { trackEngagement } from '../utils/analytics';

const Tools = ({ setCurrentSection }) => {
  const tools = [
    {
      id: 1,
      icon: '🧘',
      title: 'Breathing Exercises',
      description: 'Learn deep breathing techniques to calm your mind and body during moments of anger.',
      benefits: ['Reduces stress', 'Lowers blood pressure', 'Improves focus']
    },
    {
      id: 2,
      icon: '📝',
      title: 'Anger Journal',
      description: 'Track your anger triggers and responses to identify patterns and develop better coping strategies.',
      benefits: ['Self-awareness', 'Pattern recognition', 'Progress tracking']
    },
    {
      id: 3,
      icon: '⏰',
      title: 'Time-Out Technique',
      description: 'Take a step back when you feel anger rising to prevent impulsive reactions.',
      benefits: ['Prevents escalation', 'Gives perspective', 'Reduces regret']
    },
    {
      id: 4,
      icon: '💭',
      title: 'Cognitive Reframing',
      description: 'Change your perspective on situations to reduce anger and find constructive solutions.',
      benefits: ['Better problem-solving', 'Reduced stress', 'Improved relationships']
    },
    {
      id: 5,
      icon: '🏃',
      title: 'Physical Activity',
      description: 'Channel your energy into exercise to release tension and improve mood.',
      benefits: ['Endorphin release', 'Stress reduction', 'Better sleep']
    },
    {
      id: 6,
      icon: '🎯',
      title: 'Progressive Relaxation',
      description: 'Systematically relax your muscles to release physical tension associated with anger.',
      benefits: ['Muscle relaxation', 'Mental clarity', 'Better sleep']
    }
  ];

  const handleToolClick = (toolTitle) => {
    trackEngagement('tools', 'tool_clicked');
    trackEngagement('tools', toolTitle.toLowerCase().replace(/\s+/g, '_'));
  };

  const handleGetStartedClick = () => {
    trackEngagement('tools', 'get_started_clicked');
    if (setCurrentSection) {
      setCurrentSection('resources');
    }
  };

  return (
    <section className="tools">
      <div className="tools-container">
        <div className="tools-header">
          <h2 className="tools-title">Anger Management Tools</h2>
          <p className="tools-subtitle">
            Discover practical tools and techniques to help you manage anger effectively 
            and create a more peaceful life.
          </p>
        </div>
        
        <div className="tools-grid">
          {tools.map(tool => (
            <div key={tool.id} className="tool-card">
              <div className="tool-icon">{tool.icon}</div>
              <h3 className="tool-title">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
              <div className="tool-benefits">
                <h4>Benefits:</h4>
                <ul>
                  {tool.benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
              <button 
                className="tool-button"
                onClick={() => {
                  handleToolClick(tool.title);
                  if (setCurrentSection) {
                    setCurrentSection('resources');
                  }
                }}
              >
                Learn More
              </button>
            </div>
          ))}
        </div>
        
        <div className="tools-cta">
          <h3>Ready to Start Your Journey?</h3>
          <p>Choose a tool that resonates with you and begin practicing today.</p>
          <button 
            className="cta-button"
            onClick={handleGetStartedClick}
          >
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
};

export default Tools; 